
import { useState, useRef, useEffect } from 'react';
import Config from '../Config';
import '../Chat.css'; 
 
export function ClientExpertBox(props)
{     
    
  
    const [expertId,setExpertId] = useState(0);
    const [expertData,setExpertData] = useState(props.expertData);
  

    const rozpocznijChat = () => {
        
        let sendData = ({
            expertId:props.userData.expertId            
        })

        fetch(Config.url+'/rest,start_chat',{
            method:'POST',
            body: JSON.stringify(sendData), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.userData.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
                    
            if(res.status=='ok')
            {
                props.setUser(
                    props.userData.userType,
                    props.apiKey,
                    res.chat_id,
                    res.crypt,
                    res.saldo,
                    props.userData.email,
                    props.userData.expertId,
                    props.userData.client,
                    props.userData.orderId,
                    props.userData.stawka_klient
                );

            }
            else
            {
                //alert('coś poszło nie tak');
            }

            setExpertData(res);
        })
        .catch(err => {
            console.log("Err " + err);
        });

        return false;
    }

    if(props.expertData==null)
    {
        return <div></div>
    }

    //<a href="zamow_rozmowe,2962" class="mw-button mw-button-big">Rozpocznij czat</a>    
    var rozpoczniChat = <strong className='mw-expert-card__contact_text'>Aby rozpocząć czat należy podać adres email</strong>    

    if(props.userData.apiKey.length>5)
    {   
        if(props.userData.saldo<props.userData.stawka_klient)
            var rozpoczniChat = <div className='start_chat_saldo'><strong>Zbyt niskie saldo aby rozpocząć rozmowę</strong></div>    
        else
            var rozpoczniChat = <span class="mw-button mw-button-big" onClick={rozpocznijChat}>Rozpocznij czat</span>    
    }

    
   

    if(props.userData.expertId===0)
    {
        return (
            <div>
                
            </div>
        )
    }
    else{
        
        return (
            <div id="exp_9998" className='mw-expert-card mw-expert-card--free' data-status-label="WOLNY">
                    <div class="mw-expert-card__header">    
                        <div class="mw-expert-card__avatar">
                            <a>
                                <picture>
                                    <source type="image/webp" srcset={props.expertData.awatar.webp} />
                                    <source type="image/jpeg" srcset={props.expertData.awatar.jpeg} />
                                    <img alt={props.expertData.data.t0_nick} src={props.expertData.awatar.jpeg} />
                                </picture>
                            </a>
                        </div>  
                        <div class="mw-expert-card__details">        
                            <h3 class="mw-expert-card__name">
                                <a>{props.expertData.data.t0_nick}</a>
                            </h3>        
                                <div class="mw-expert-card__zodiac">            
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">                
                                        <path d="m511.582 27.466-29.28-27.253c-.231.248-23.622 25.048-63.232 49.415-35.783 22.013-94.059 48.437-162.139 48.437-69 0-126.634-26.641-162.838-48.543-40.368-24.421-64.496-49.274-64.735-49.522l-28.875 27.681c1.093 1.142 27.27 28.265 71.772 55.378 27.9 16.998 56.894 30.208 86.251 39.425-65.139 34.907-109.55 103.651-109.55 182.581 0 114.14 92.859 207 207 207s207-92.86 207-207c0-78.565-43.997-147.045-108.645-182.102 29.692-9.25 58.909-22.646 86.883-39.984 43.834-27.168 69.324-54.369 70.388-55.513zm-88.626 277.599c0 92.084-74.916 167-167 167s-167-74.916-167-167c0-91.667 76.462-167 167.976-167 91.999 0 166.024 75.745 166.024 167z"></path>            
                                    </svg>
                                    {props.expertData.data.t0_znak_zodiaku}        
                                </div>        
                                    <ul class="mw-expert-card__fields">
                                        {   
                                        
                                            props.expertData.data.dziedziny_wybrane.map( (row, ix ) => {
                                                return (
                                                    <a>{row}, </a>
                                                )
                                                

                                            } )
                                        }
                                        
                                        {
                                            props.expertData.data.kategorie_wybrane.map( (row, ix ) => {
                                                return (
                                                    <a>{row}, </a>
                                                )
                                                

                                            } )
                                        }
                                    </ul>    
                        </div>  
                    </div>    
                    <div class="mw-expert-card__cta">    
                        <center>
                            {rozpoczniChat}
                        </center>
                    </div>
                    <div class="mw-expert-card__contact">    
                        <div>
                            <strong>Koszt rozmowy wynosi {props.expertData.data.t2_stawka_klient} zł/min brutto</strong>
                            
                        </div>
                    </div>
            </div>
        )

    }

    
   
}
